import script from "./AppInfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInfoSection.vue?vue&type=script&setup=true&lang=js"

import "./AppInfoSection.vue?vue&type=style&index=0&id=57df2be8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57df2be8"]])

export default __exports__